import { render, staticRenderFns } from "./commonScrom.vue?vue&type=template&id=befe74b6"
import script from "./commonScrom.vue?vue&type=script&lang=js"
export * from "./commonScrom.vue?vue&type=script&lang=js"
import style0 from "./commonScrom.vue?vue&type=style&index=0&id=befe74b6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports